import {
  columnVisibilityFeature,
  createSortedRowModel,
  metaHelper,
  rowSortingFeature,
  sortFn_alphanumeric,
  sortFn_basic,
  sortFn_datetime,
  sortFn_text,
  tableFeatures,
} from "@tanstack/react-table"

type ColumnMeta = {
  align?: "left" | "right" | "center"
  className?: string
  colSpan?: number
  noPadding?: boolean
  type?: string
  hasTitle?: boolean
}

export const features = tableFeatures({
  columnVisibilityFeature,
  columnMeta: metaHelper<ColumnMeta>(),
})

export type Features = typeof features

export const sortingFeatures = tableFeatures({
  columnVisibilityFeature,
  rowSortingFeature,
  sortedRowModel: createSortedRowModel(),
  sortFns: {
    alphanumeric: sortFn_alphanumeric,
    basic: sortFn_basic,
    datetime: sortFn_datetime,
    text: sortFn_text,
  },
  columnMeta: metaHelper<ColumnMeta>(),
})

export type SortingFeatures = typeof sortingFeatures
